module.exports = __webpack_public_path__ + "static/media/propShaft.ef6b01b3.svg";